import { change as changeFormValue, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useEffect } from 'react';
import EtgFares from '../components/EtgFares';
import { etgFares } from '../index';
import { jsx as _jsx } from "react/jsx-runtime";
export const YOUR_SELECTED_TRIP = 'your-selected-trip';
const EtgFaresContainer = props => {
  const {
    prevSelectedOptionId,
    setSelectedEtgFareOption,
    options,
    ...rest
  } = props;
  const prevSelectedOption = options === null || options === void 0 ? void 0 : options.find(({
    id
  }) => id === prevSelectedOptionId);
  useEffect(() => {
    if (prevSelectedOption) {
      setSelectedEtgFareOption(prevSelectedOption);
    }
  }, [setSelectedEtgFareOption, prevSelectedOption]);
  return /*#__PURE__*/_jsx(EtgFares, {
    options: options,
    setSelectedEtgFareOption: setSelectedEtgFareOption,
    ...rest
  });
};
const mapStateToProps = state => {
  const {
    value
  } = formValueSelector(YOUR_SELECTED_TRIP)(state, etgFares.name) || {};
  return {
    selectedEtgFareOption: value
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setSelectedEtgFareOption: selectedOption => dispatch(changeFormValue(YOUR_SELECTED_TRIP, `${etgFares.name}.value`, selectedOption))
  };
};
const withReduxForm = () => reduxForm({
  form: YOUR_SELECTED_TRIP,
  enableReinitialize: true
});
const connectToStore = compose(connect(mapStateToProps, mapDispatchToProps), withReduxForm());
export default connectToStore(EtgFaresContainer);
//# sourceMappingURL=EtgFaresContainer.js.map